@if (show) {
  <div class="modal-backdrop">
    <div class="modal-window">
      <div class="modal-header">
        <h2>{{ modalTitle }}</h2>
        <button class="btn btn-icon" (click)="onClose()">✕</button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="onSubmit()">
          <div class="form-row">
            <label>Lobby Name *</label>
            <input type="text" [(ngModel)]="formData.name" name="name" required />
          </div>
          <div class="form-row">
            <label>Description</label>
            <textarea [(ngModel)]="formData.description" name="description" rows="3"></textarea>
          </div>
          <div class="form-row">
            <label>Theme *</label>
            <select [(ngModel)]="formData.themeId" name="themeId" required>
              <option [ngValue]="''" disabled>Select a theme</option>
              @for (t of themes; track t) {
                <option [value]="t._id">{{ t.name }}</option>
              }
            </select>
            @if (themesLoading) {
              <small>Loading themes…</small>
            }
          </div>
          <div class="form-grid">
            <div class="form-row">
              <label>Entry Fee *</label>
              <input type="number" [(ngModel)]="formData.entryFee" name="entryFee" min="0" required />
            </div>
            <div class="form-row">
              <label>Max Participants *</label>
              <input type="number" [(ngModel)]="formData.maxParticipants" name="maxParticipants" min="1" required />
            </div>
          </div>
          <fieldset class="fieldset">
            <legend>Location *</legend>
            <div class="form-grid">
              <div class="form-row"><label>City *</label><input type="text" [(ngModel)]="formData.location.city" name="city" required /></div>
              <div class="form-row"><label>State</label><input type="text" [(ngModel)]="formData.location.state" name="state" /></div>
              <div class="form-row"><label>Country *</label><input type="text" [(ngModel)]="formData.location.country" name="country" required /></div>
            </div>
            <div class="form-grid">
              <div class="form-row"><label>Latitude *</label><input type="number" step="any" [(ngModel)]="formData.location.coordinates.latitude" name="latitude" required /></div>
              <div class="form-row"><label>Longitude *</label><input type="number" step="any" [(ngModel)]="formData.location.coordinates.longitude" name="longitude" required /></div>
            </div>
          </fieldset>
          <fieldset class="fieldset">
            <legend>Recurring</legend>
            <div class="form-row">
              <label>Daily Time</label>
              <input type="time" [(ngModel)]="formData.recurringSchedule.dailyTime" name="dailyTime" />
            </div>
          </fieldset>
          <fieldset class="fieldset">
            <legend>Round Questions</legend>
            <div class="questions-list">
              @for (q of formData.roundQuestions; track q; let i = $index) {
                <div class="question-item">
                  <div class="form-grid">
                    <div class="form-row">
                      <label>Round #{{ q.roundNumber }}</label>
                      <input type="text" [(ngModel)]="q.questionText" name="questionText-{{i}}" placeholder="Question text" />
                    </div>
                    <div class="form-row actions">
                      <button type="button" class="btn btn-outline" (click)="removeRoundQuestion(i)">Remove</button>
                    </div>
                  </div>
                </div>
              }
            </div>
            <button type="button" class="btn btn-outline" (click)="addRoundQuestion()">+ Add Question</button>
          </fieldset>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline" (click)="onClose()" [disabled]="creating">Cancel</button>
            <button type="submit" class="btn btn-primary custom-gradient-btn" [disabled]="creating">{{ submitButtonText }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
}